// extracted by mini-css-extract-plugin
var _1 = "TasksTableRowComponents-modulecell__QoT55 TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
var _2 = "TasksTableRowComponents-modulecellContainer__RAjxU";
export { _1 as "cell", _2 as "cellContainer" }
